export const ON_LANDING_EVENT_PAGE = 'On Landing Event Page';
export const ON_REGISTER_USER = 'User Registration';
export const ON_REGISTER_USER_STATUS = 'User Registration Api Status';
export const ON_JOIN_SESSION_CLICK = 'Click On Join Session';
export const ON_JOIN_SESSION = 'Joining Session';
export const ON_WATCH_RECORDING_CLICK = 'Click On Watch recording';
export const ON_WATCH_RECORDING = 'Watch Recording';
export const ON_REMIND_ME_CLICK = 'Click On Remind Me';
export const ON_ADD_EVENT_CALENDER_CLICK = 'Click On Add Event Calender';
export const ON_REMIND_ME_CALENDER_CLICK = 'Click On Remind Me Calender';
export const ON_EVENT_DATE_TAB_CLICK = 'Click On Event Date Tab';
export const ON_EVENT_FILTER_CLICK = 'Click On Event Filter';
export const ON_COPY_LINK = 'COPY LINK';
export const ON_OVERVIEW_TAB_CLICK = 'Overview Tab Click';
export const ON_AGENDA_TAB_CLICK = 'Agenda Tab Click';
export const ON_SPEAKER_TAB_CLICK = 'Speaker Tab Click';
export const ON_EVENT_SOCIAL_MEDIA_CLICK = 'Event Social Media Click';
export const ON_EVENT_SPEAKER_SOCIAL_MEDIA_CLICK = 'Event Speaker Social Media Link';
export const ON_EVENT_SPEAKER_CLICK = 'Event Speaker Click';
